/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum PaymentMethod {
  CreditCard = "credit_card",
  BankAccount = "bank_account",
  Cash = "cash",
  Cheque = "cheque",
  Wire = "wire",
  Eft = "eft",
  InteracEtransfer = "interac_etransfer",
}

export function instanceOfPaymentMethod(value: any): boolean {
  for (const key in PaymentMethod) {
    if (Object.prototype.hasOwnProperty.call(PaymentMethod, key)) {
      if (PaymentMethod[key as keyof typeof PaymentMethod] === value) {
        return true;
      }
    }
  }
  return false;
}

export function PaymentMethodFromJSON(json: any): PaymentMethod {
  return PaymentMethodFromJSONTyped(json, false);
}

export function PaymentMethodFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaymentMethod {
  return json as PaymentMethod;
}

export function PaymentMethodToJSON(value?: PaymentMethod | null): any {
  return value as any;
}

export function PaymentMethodToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): PaymentMethod {
  return value as PaymentMethod;
}
